import { useState, useContext, useEffect } from 'react'
import { IntakeContext } from '../context/IntakeContext'
import { Box, Fade, Grid, IconButton, Tooltip, Typography } from '@mui/material'
import { format, subYears, differenceInYears } from 'date-fns'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import { useFieldFocus } from 'context/FieldFocusContext'
import { WheelSelector } from './WheelSelector'
import { Help } from '@mui/icons-material'

const OnboardingIncome = ({
  header,
  subHeader,
  fieldLabel,
  fieldPlaceholder,
  fieldHelpText,
  wheelFormatterText,
  wheelStartingValue,
  wheelIncrement,
  wheelOptionCount,
  keyToUpdate,
  startingTextWidth,
}) => {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)

  const currencyValue = intakeState?.[keyToUpdate] || wheelStartingValue

  const [isMobile, setIsMobile] = useState(window.innerWidth < 600)
  const [tooltipSwap, setTooltipSwap] = useState(window.innerWidth < 992)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600)
      setTooltipSwap(window.innerWidth < 992)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const fieldId = 'fieldHelp'
  const newHelpText = fieldHelpText
  const { handleFocus, handleBlur, registerHelpField } = useFieldFocus()
  useEffect(() => {
    registerHelpField(fieldId, newHelpText)
  }, [fieldId])

  return (
    <Box sx={{ textAlign: 'left' }}>
      <Box
        onMouseEnter={(e) => handleFocus(fieldId, e.currentTarget)}
        onMouseLeave={() => handleBlur()}
      >
        <Box mb={1}>
          <Typography variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
            {header || 'What is your annual salary?'}
            {tooltipSwap && fieldHelpText && (
              <Tooltip
                TransitionComponent={Fade}
                title={fieldHelpText}
                placement="top"
                color="info"
                enterTouchDelay={0}
                leaveTouchDelay={3000}
              >
                <IconButton size="small" color="dark">
                  <Help sx={{ marginTop: '-10px' }} />
                </IconButton>
              </Tooltip>
            )}
          </Typography>
        </Box>
        <Typography
          variant="body1"
          sx={{ lineHeight: '1.2' }}
          fontSize={{ xs: '16px', sm: '20px' }}
        >
          {subHeader ||
            'This is useful for us to calculate your pension in retirement'}
        </Typography>
      </Box>
      <Grid container columnSpacing={3} mt={4}>
        <Grid item xs={12} mb={4}>
          {isMobile ? (
            <Grid item xs={12}>
              <WheelSelector
                options={Array.from(
                  { length: wheelOptionCount },
                  (_, i) => (i + 1) * wheelIncrement
                )} // 0..100
                initialValue={currencyValue}
                onChange={(val) => {
                  if (keyToUpdate === 'baseSalary') {
                    updateIntakeStateAtKey({
                      baseSalary: val,
                      highThree: val * 0.96,
                    })
                  } else {
                    updateIntakeStateAtKey({
                      [keyToUpdate]: val,
                    })
                  }
                }}
                visibleCount={20}
                optionItemHeight={40}
                width={360}
                formatter={(val) => `$${val.toLocaleString()}`}
                suffixText={wheelFormatterText}
                suffixGap={16}
              />
            </Grid>
          ) : (
            <Grid item xs={12}>
              {renderMuiFormField({
                required: true,
                inputType: 'currencyFloat',
                id: 'baseSalary',
                placeholder: fieldPlaceholder || '$62,000.00',
                label: fieldLabel || 'Annual Salary',
                helpText: fieldHelpText,
                value: currencyValue,
                enableHelpText: fieldHelpText ? true : false,
                onChange: (e) => {
                  if (keyToUpdate === 'baseSalary') {
                    updateIntakeStateAtKey({
                      baseSalary: e,
                      highThree: e * 0.96,
                    })
                  } else {
                    updateIntakeStateAtKey({
                      [keyToUpdate]: e,
                    })
                  }
                },
              })}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  )
}
export default OnboardingIncome
